import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

class Features extends Component {
  render() {
    return (
      <React.Fragment>
        <section className="section" id="features">
          <Container>
            <Row className="align-items-center">
              <Col lg="5" className="order-2 order-lg-1">
                <div className="features-box mt-5 mt-lg-0">
                  <h3>
                    Un centro de sanación integral ofreciendo terapias modernas y efectivas
                  </h3>
                  <p className="text-muted web-desc">
                    En Yosoylaquesana, equilibramos el cuerpo, la mente y el espíritu, logrando armonía y liberación de la esencia divina.
                  </p>
                  <ul className="text-muted list-unstyled mt-4 features-item-list">
                    <li className="">
                      Nos esforzamos en ofrecer terapias de sanación física, emocional y espiritual.
                    </li>
                    <li className="">
                      La cirugía astral y las liberaciones son nuestras especialidades para un bienestar integral.
                    </li>
                    <li className="">
                      Participa en nuestros talleres de aprendizaje espiritual.
                    </li>
                  </ul>
                  {/* <Link
                    to="#"
                    className="btn btn-primary mt-4 waves-effect waves-light"
                  >
                    Learn More <i className="mdi mdi-arrow-right"></i>
                  </Link> */}
                </div>
              </Col>
              <Col lg={{ size: 7, order: 2 }} xs={{ order: 1 }}>
                <div className="features-img mx-auto me-lg-0">
                  <img
                    src="assets/images/slqs.jpg"
                    alt="macbook"
                    className="img-fluid"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Features;
